export enum WellType {
  PRODUCER,
  INJECTOR
}
